export enum InputType {
    BLOCK = 'BLOCK',
    INLINE = 'INLINE',
}
